import * as ImagePath from "./ImagePath";
import * as Routes from "../../../constants/Routes";
import {useNavigate} from "react-router-dom";

export default function Menu() {
    const navigate = useNavigate();

    return (
        <nav className="navbar">
            <ul className="navbar-menu">
                <button onClick={() => navigate(Routes.USER)} className="nav-wrapper">
                    <div className="svg-wrapper">
                        <img src={ImagePath.icon1} alt="icon"/>
                    </div>
                    <div className="nav-title">
                        사용자 관리
                    </div>
                </button>
                <button onClick={() => navigate(Routes.PAYMENT)} className="nav-wrapper">
                    <div className="svg-wrapper">
                        <img src={ImagePath.icon2} alt="icon"/>
                    </div>
                    <div className="nav-title">
                        결제 관리
                    </div>
                </button>
                <button onClick={() => navigate(Routes.LICENSE)} className="nav-wrapper">
                    <div className="svg-wrapper">
                        <img src={ImagePath.icon3} alt="icon"/>
                    </div>
                    <div className="nav-title">
                        라이선스 관리
                    </div>
                </button>
                <button onClick={() => navigate(Routes.NOTICE)} className="nav-wrapper">
                    <div className="svg-wrapper">
                        <img src={ImagePath.icon5} alt="icon"/>
                    </div>
                    <div className="nav-title">
                        공지사항 관리
                    </div>
                </button>
                <button onClick={() => navigate(Routes.INQUIRY)} className="nav-wrapper">
                    <div className="svg-wrapper">
                        <img src={ImagePath.icon6} alt="icon"/>
                    </div>
                    <div className="nav-title">
                        문의 관리
                    </div>
                </button>
                <button onClick={() => navigate(Routes.FAQ)} className="nav-wrapper">
                    <div className="svg-wrapper">
                        <img src={ImagePath.icon7} alt="icon"/>
                    </div>
                    <div className="nav-title">
                        FAQ 관리
                    </div>
                </button>
                <button onClick={() => navigate(Routes.LECTURE)} className="nav-wrapper">
                    <div className="svg-wrapper">
                        <img src={ImagePath.icon8} alt="icon"/>
                    </div>
                    <div className="nav-title">
                        강의 관리
                    </div>
                </button>
            </ul>
        </nav>
    );
}